import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import {FormRow} from './form/FormElements';
import {Centered500} from './container/CenteredContainer';
import ActionButtonRow from './ActionButtonRow';
import constants from '../parameters/constants';
import styled from 'styled-components';
import ErrorMessage from './ErrorMessage';
import convertErrors from '../helpers/errorHelper';
import filterOutNotDefinedValues from '../helpers/filterOutNotDefinedValues';
import {withNamespaces} from 'react-i18next';
const logo = require('../img/hauser-wirth-logo.png');
const background = require('../img/background.jpg');

const LogoContainer = styled.div`
  padding: 20px;
  background: ${constants.primaryColor};
  margin: 0 -15px 20px -15px;
`;
const BackgroundImage = styled.div`
  height: 100vh;
  width: 100vw;
  background: url(${background});
  background-size: cover;
`;

const StyledActionButtonRow = styled(ActionButtonRow)`
  margin: 20px -15px 0px;
  padding: 10px 20px;
`;

class LogIn extends Component {
  constructor() {
    super();
    this.state = {loginName: '', loginToken: ''};
  }
  login = () =>
    this.props
      .login(filterOutNotDefinedValues(this.state))
      .then(() => {
        this.props.rerender();
        this.props.history.replace('/users');
      })

      .catch((rawErrors) => {
        const {t} = this.props;
        let errors = convertErrors({...rawErrors, t: t});
        this.setState({errors});
        console.log('there was an error sending the query', errors);
      });

  render() {
    const {t} = this.props;
    return (
      <BackgroundImage>
        <ErrorMessage errors={this.state.errors} clearErrors={() => this.setState({errors: []})} />
        <Centered500>
          <LogoContainer>
            <img src={logo} alt='Hauser & Wirth Logo' width='250px' />
          </LogoContainer>
          <FormRow>
            <TextField
              autoFocus
              type='text'
              hintText='Login-Name'
              value={this.state.loginName}
              fullWidth={true}
              onChange={(event) => {
                this.setState({loginName: event.target.value});
              }}
              onKeyPress={(target) => {
                if (target.charCode === 13) {
                  this.login();
                }
              }}
            />
          </FormRow>
          <FormRow>
            <TextField
              type='password'
              hintText='Login-Token'
              value={this.state.loginToken}
              fullWidth={true}
              onChange={(event) => {
                this.setState({loginToken: event.target.value});
              }}
              onKeyPress={(target) => {
                if (target.charCode === 13) {
                  this.login();
                }
              }}
            />
          </FormRow>
          <StyledActionButtonRow>
            <div />
            <div>
              <FlatButton primary onClick={this.login} label={t('logIn.login')} />
            </div>
          </StyledActionButtonRow>
        </Centered500>
      </BackgroundImage>
    );
  }
}
export default withNamespaces()(LogIn);



// WEBPACK FOOTER //
// ./src/components/Login.js